export default "__VITE_ASSET__CRUZQqOq__"